export const RenderOption = ({ record, label, ...props }) => (
  <div {...props} key={record.id || label}>
    {label}
  </div>
)
